import { RichTextOptions } from '../model/rich-text-options';

export class RichTextOptionsBuilder {
  public options = new RichTextOptions();

  public setBold(bold: boolean): RichTextOptionsBuilder {
    this.options.bold.set(bold);
    return this;
  }

  public setItalic(italic: boolean): RichTextOptionsBuilder {
    this.options.italic.set(italic);
    return this;
  }

  public setUnderline(underline: boolean): RichTextOptionsBuilder {
    this.options.underline.set(underline);
    return this;
  }

  public setStrikethrough(strikethrough: boolean): RichTextOptionsBuilder {
    this.options.strikethrough.set(strikethrough);
    return this;
  }

  public setColor(color: boolean): RichTextOptionsBuilder {
    this.options.forecolor.set(color);
    return this;
  }

  public setHighlight(highlight: boolean): RichTextOptionsBuilder {
    this.options.backcolor.set(highlight);
    return this;
  }

  public setNumList(numList: boolean): RichTextOptionsBuilder {
    this.options.numlist.set(numList);
    return this;
  }

  public setBulletList(bulletList: boolean): RichTextOptionsBuilder {
    this.options.bullist.set(bulletList);
    return this;
  }

  public setHr(hr: boolean): RichTextOptionsBuilder {
    this.options.hr.set(hr);
    return this;
  }

  public setTable(table: boolean): RichTextOptionsBuilder {
    this.options.table.set(table);
    return this;
  }

  public setAutolink(autolink: boolean): RichTextOptionsBuilder {
    this.options.autolink.set(autolink);
    return this;
  }

  public setLink(link: boolean): RichTextOptionsBuilder {
    this.options.link.set(link);
    return this;
  }

  public setEmoticons(emoticons: boolean): RichTextOptionsBuilder {
    this.options.emoticons.set(emoticons);
    return this;
  }

  public setCodeSample(codeSample: boolean): RichTextOptionsBuilder {
    this.options.codesample.set(codeSample);
    return this;
  }

  public setFullScreen(fullScreen: boolean): RichTextOptionsBuilder {
    this.options.fullscreen.set(fullScreen);
    return this;
  }

  public setHeight(height: number): RichTextOptionsBuilder {
    this.options.height.set(height);
    return this;
  }

  public setResize(resize: boolean | 'both'): RichTextOptionsBuilder {
    this.options.resize.set(resize);
    return this;
  }

  public setImagesFileType(imagesFileType: string): RichTextOptionsBuilder {
    this.options.imagesFilesTypes.set(imagesFileType);
    return this;
  }

  public setFilePickerTypes(filePickerTypes: string): RichTextOptionsBuilder {
    this.options.filePickerTypes.set(filePickerTypes);
    return this;
  }

  public enableAll(): RichTextOptionsBuilder {
    this.options.settingsKeys.forEach((key) => {
      this.options[key].set(true);
    });
    this.options.pluginsKeys.forEach((key) => {
      this.options[key].set(true);
    });
    return this;
  }

  public setDefaultConfig(): RichTextOptionsBuilder {
    this.setBold(true)
      .setItalic(true)
      .setUnderline(true)
      .setStrikethrough(true)
      .setColor(true)
      .setBulletList(true)
      .setAutolink(true)
      .setLink(true)
      .setFullScreen(true)
      .setHeight(300)
      .setResize('both');
    return this;
  }

  public build(): RichTextOptions {
    return this.options;
  }
}
